// extracted by mini-css-extract-plugin
export default {"card":"CardStyles_card__eSo5M","cardContent":"CardStyles_cardContent__CU1LE"};